import React from 'react';
import { getHeadingStyle } from '../StructuredText/logic';
import { BlockNode } from 'datocms-structured-text-utils';
import { render } from 'datocms-structured-text-to-plain-text';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { StructuredText } from '../StructuredText';
import { fontBodyMini } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';

export const ArticleParagraphComponent = ({
  block,
  index,
  headingElementsRef,
}: any) => {
  return (
    <div
      className={classNames(
        'DatoCmsParagraph ArticleParagraph',
        'my-24 w-full md:my-40',
      )}
    >
      <StructuredText
        text={block.paragraphText}
        renderHeading={({ node, key, children }: any) => {
          const HeadingElement: any = `h${node.level}`;
          const textStyle = getHeadingStyle(node.level);
          const id =
            render(node as BlockNode)?.replace(/\W+/g, '-') ?? undefined;

          return (
            <HeadingElement
              ref={(element: any) => {
                const headings =
                  headingElementsRef && new Set(headingElementsRef.current);
                if (element && headingElementsRef && !headings.has(element)) {
                  headingElementsRef?.current.push(element);
                }
              }}
              id={id}
              key={`${index}-${key}`}
              className={`${textStyle} pb-32 pt-8`}
            >
              {children}
            </HeadingElement>
          );
        }}
        renderListItem={({ key, children }) => (
          <li key={`${index}-${key}`} className="py-8 pl-12">
            {children}
          </li>
        )}
        renderList={({ node, key, children }) => {
          const List: keyof JSX.IntrinsicElements =
            node.style === 'bulleted' ? 'ul' : 'ol';
          return (
            <List
              key={`${index}-${key}`}
              className={classNames(
                'blog-list ml-1em py-8',
                fontBodyMini,
                node.style === 'bulleted' ? 'list-disc' : 'list-decimal',
              )}
            >
              {children}
            </List>
          );
        }}
      />
    </div>
  );
};

export default ArticleParagraphComponent;
